import { Box, Button, useTheme } from '@mui/material';
import React, { useState } from 'react';
import {
    DownloadRequiredDocumentsButton,
    InternalDocumentsTab,
    RequiredDocumentsTab,
} from '@europrocurement/l2d-modules';

import {
    DOC_TYPE_DOWNLOADABLE,
    DOC_TYPE_INTERNAL,
    DOC_TYPE_REQUIRED,
} from '@europrocurement/l2d-domain';
import DocumentTabFooterActions from '../DocumentTabFooterActions/DocumentTabFooterActions';
import DownloadableDocumentsTab from '../DownloadableDocumentsTab/DownloadableDocumentsTab';

type displayedBlocsType = {
    required: boolean;
    internal: boolean;
    downloadable: boolean;
};
type keyType = keyof displayedBlocsType;

const DocumentsTabs: React.FunctionComponent = function () {
    const { palette } = useTheme();

    const [displayedBlocs, setDisplayedBlocs] = useState<displayedBlocsType>({
        required: true,
        internal: true,
        downloadable: true,
    });

    // Create a button for toggling the display of each document bloc
    const renderButtonDisplayBloc = (blocKey: keyType, label: string) => {
        // Define the styles for the button based on whether the bloc is displayed or not
        const sxDefault = {
            transition: 'background-color 300ms ease-in-out',
            ...(displayedBlocs[blocKey]
                ? {
                      backgroundColor: palette.primary.dark,
                      ':hover': { backgroundColor: palette.primary.main },
                  }
                : {
                      backgroundColor: palette.grey[300],
                      ':hover': { backgroundColor: palette.grey[700] },
                  }),
        };
        return (
            <Button
                variant="contained"
                sx={sxDefault}
                onClick={() =>
                    setDisplayedBlocs((prev) => ({ ...prev, [blocKey]: !prev[blocKey] }))
                }
            >
                {label}
            </Button>
        );
    };

    return (
        <Box>
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    marginBottom: '16px',
                    justifyContent: 'center',
                }}
            >
                {renderButtonDisplayBloc('required', 'Documents requis')}
                {renderButtonDisplayBloc('downloadable', 'Documents remis')}
                {renderButtonDisplayBloc('internal', 'Documents internes')}
            </Box>

            {displayedBlocs.required && (
                <RequiredDocumentsTab>
                    <DocumentTabFooterActions
                        docType={DOC_TYPE_REQUIRED}
                        addDocBtnLabel="Ajouter un document requis"
                        additionalActions={[<DownloadRequiredDocumentsButton />]}
                    />
                </RequiredDocumentsTab>
            )}

            {displayedBlocs.downloadable && (
                <DownloadableDocumentsTab>
                    <DocumentTabFooterActions
                        docType={DOC_TYPE_DOWNLOADABLE}
                        addDocBtnLabel="Ajouter un document remis"
                    />
                </DownloadableDocumentsTab>
            )}

            {displayedBlocs.internal && (
                <InternalDocumentsTab>
                    <DocumentTabFooterActions
                        docType={DOC_TYPE_INTERNAL}
                        addDocBtnLabel="Ajouter un document interne"
                    />
                </InternalDocumentsTab>
            )}
        </Box>
    );
};

export default DocumentsTabs;
